import { __extends } from 'tslib';
import classNames from 'classnames';
import moment from 'moment';
import * as React from 'react';
import { t } from '../../localization.js';
import styles from './CountDown.module.scss.js';

var Countdown = (function (_super) {
    __extends(Countdown, _super);
    function Countdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            days: 0,
            hours: 0,
            min: 0,
            sec: 0,
        };
        _this.getRoundDays = function () {
            var countDown = _this.state;
            return Math.round(countDown.days + (countDown.hours + (countDown.min + countDown.sec / 60) / 60) / 24);
        };
        _this.getDayslabel = function () {
            var daysMap = {
                0: t('0 дней'),
                1: t('1 день'),
                2: t('2 дня'),
                3: t('3 дня'),
                4: t('4 дня'),
                5: t('5 дней'),
                6: t('6 дней'),
                7: t('7 дней'),
            };
            var days = _this.getRoundDays();
            var label = daysMap[days] || '';
            if (label) {
                label = label.replace(days, '').trim();
            }
            return label;
        };
        return _this;
    }
    Countdown.prototype.UNSAFE_componentWillMount = function () {
        var date = this.calculateCountdown(this.props.date);
        date ? this.setState(date) : this.stop();
    };
    Countdown.prototype.componentDidMount = function () {
        var _this = this;
        this.interval = setInterval(function () {
            var date = _this.calculateCountdown(_this.props.date);
            date ? _this.setState(date) : _this.stop();
        }, 1000);
    };
    Countdown.prototype.componentWillUnmount = function () {
        this.stop();
    };
    Countdown.prototype.calculateCountdown = function (endDate) {
        var now = moment.utc();
        var end = moment.utc(endDate);
        var diff = end.diff(now, 'seconds');
        if (diff <= 0)
            return false;
        var timeLeft = {
            years: 0,
            days: 0,
            hours: 0,
            min: 0,
            sec: 0,
        };
        if (diff >= 365.25 * 86400) {
            timeLeft.years = Math.floor(diff / (365.25 * 86400));
            diff -= timeLeft.years * 365.25 * 86400;
        }
        if (diff >= 86400) {
            timeLeft.days = Math.floor(diff / 86400);
            diff -= timeLeft.days * 86400;
        }
        if (diff >= 3600) {
            timeLeft.hours = Math.floor(diff / 3600);
            diff -= timeLeft.hours * 3600;
        }
        if (diff >= 60) {
            timeLeft.min = Math.floor(diff / 60);
            diff -= timeLeft.min * 60;
        }
        timeLeft.sec = diff;
        return timeLeft;
    };
    Countdown.prototype.stop = function () {
        clearInterval(this.interval);
    };
    Countdown.prototype.addLeadingZeros = function (value) {
        value = String(value);
        while (value.length < 2) {
            value = '0' + value;
        }
        return value;
    };
    Countdown.prototype.render = function () {
        var countDown = this.state;
        if (countDown.days > 0) {
            return (React.createElement("div", { className: classNames(styles.countdown, this.props.className) },
                React.createElement("div", { className: styles.countdownCol },
                    React.createElement("span", { className: styles.coundownNumber + " " + styles.coundownNumberMargin }, this.getRoundDays()),
                    React.createElement("span", { className: styles.daysLabel }, this.getDayslabel()))));
        }
        else {
            return (React.createElement("div", { className: classNames(styles.countdown, this.props.className) },
                React.createElement("div", { className: styles.countdownCol },
                    React.createElement("span", { className: styles.coundownNumber }, this.addLeadingZeros(countDown.hours)),
                    React.createElement("span", { className: styles.coundownNumber }, ':')),
                React.createElement("div", { className: styles.countdownCol },
                    React.createElement("span", { className: styles.coundownNumber }, this.addLeadingZeros(countDown.min)),
                    React.createElement("span", { className: styles.coundownNumber }, ':')),
                React.createElement("div", { className: styles.countdownCol },
                    React.createElement("span", { className: styles.coundownNumber }, this.addLeadingZeros(countDown.sec)))));
        }
    };
    return Countdown;
}(React.PureComponent));

export { Countdown as default };
//# sourceMappingURL=CountDown.js.map
